// import { mapActions, mapState } from 'vuex'
import { mapActions } from 'vuex'
const Mixin = {
  methods: {
    ...mapActions(['getMapInfoSD', 'getHistoryDeviceLogSD', 'getDeviceParamsSD', 'getDeviceLogListSD', 'getAreaListSD', 'getParams'])
  }
//   computed: {
//     ...mapState({
//       MapInfoSD: state => state.moduleSD.MapInfoSD,
//       HistorydeviceLogSD: state => state.moduleSD.HistorydeviceLogSD
//     })
//   }
}
export default Mixin
